var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrofiesImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 0H3.66667C3.11458 0 2.66458 0.425781 2.68542 0.941406C2.68958 1.04492 2.69375 1.14844 2.7 1.25H0.5C0.222917 1.25 0 1.45898 0 1.71875C0 3.52734 0.697917 4.78516 1.63542 5.63867C2.55833 6.48047 3.68333 6.9043 4.5125 7.11914C5 7.24609 5.33333 7.62695 5.33333 8.00977C5.33333 8.41797 4.97917 8.75 4.54375 8.75H4C3.63125 8.75 3.33333 9.0293 3.33333 9.375C3.33333 9.7207 3.63125 10 4 10H8C8.36875 10 8.66667 9.7207 8.66667 9.375C8.66667 9.0293 8.36875 8.75 8 8.75H7.45625C7.02083 8.75 6.66667 8.41797 6.66667 8.00977C6.66667 7.62695 6.99792 7.24414 7.4875 7.11914C8.31875 6.9043 9.44375 6.48047 10.3667 5.63867C11.3021 4.78516 12 3.52734 12 1.71875C12 1.45898 11.7771 1.25 11.5 1.25H9.3C9.30625 1.14844 9.31042 1.04688 9.31458 0.941406C9.33542 0.425781 8.88542 0 8.33333 0ZM1.01875 2.1875H2.77708C2.96667 3.94727 3.38542 5.12305 3.85833 5.91016C3.33958 5.69531 2.8 5.39258 2.33333 4.9668C1.66667 4.35938 1.125 3.48242 1.02083 2.1875H1.01875ZM9.66875 4.9668C9.20208 5.39258 8.6625 5.69531 8.14375 5.91016C8.61667 5.12305 9.03542 3.94727 9.225 2.1875H10.9833C10.8771 3.48242 10.3354 4.35938 9.67083 4.9668H9.66875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrofiesImage);
export default __webpack_public_path__ + "static/media/trofies-image.51f6fb89f59240775a7b28e2a6218959.svg";
export { ForwardRef as ReactComponent };